var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 347.6 172",
    style: {
      enableBackground: "new 0 0 347.6 172"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#EA3E24;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st4{fill:#225FBC;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.825,
    y1: 172.2169,
    x2: 173.825,
    y2: 0.2445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#225FBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FB2F0"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)"
    },
    points: "0,172 175.7,172 347.7,0 0,0 0,172  "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.3,32.3l-34.2,0v81.4l-29.9-81.4h-29.6l-25.5,68c-2.7-17.1-20.5-23.1-34.4-27.5c-9.2-3-19-7.3-18.9-12.1 c0.1-3.9,5.3-7.6,15.5-7.1c6.9,0.4,13,0.9,25,6.8l11.9-20.7c-11-5.6-26.3-9.2-38.8-9.2h-0.1c-14.6,0-26.7,4.7-34.2,12.5 C7.8,48.4,5,55.3,4.9,63C4.7,73.5,8.5,80.9,16.6,86.9c6.8,5,15.6,8.3,23.3,10.7c9.5,2.9,17.3,5.5,17.2,10.9c0,2-0.8,3.8-2.2,5.3 c-2.4,2.5-6,3.4-11,3.5c-9.7,0.2-16.9-1.3-28.3-8.1l-10.6,21c11.4,6.5,25,10.3,38.7,10.3l1.8,0c12-0.2,21.7-3.7,29.5-9.9 c0.4-0.3,0.8-0.7,1.2-1.1l-3.4,9.2h31.1l5.2-15.9c5.5,1.8,11.7,2.9,18.3,2.9c6.4,0,12.5-1,17.8-2.7l5,15.7h50.7v-32.9h11.1 c26.7,0,42.5-13.6,42.5-36.4C254.4,44,239,32.3,206.3,32.3z M127.2,102c-4,0-7.7-0.7-11-1.9l10.9-34.2h0.2l10.6,34.3 C134.8,101.3,131.1,102,127.2,102z M208.3,82.3h-7.5V54.7h7.5c10.1,0,18.1,3.3,18.1,13.6C226.4,79,218.4,82.3,208.3,82.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.7,160.8c0-5.3,4-9.3,9.1-9.3c5,0,9,4,9,9.3c0,5.4-4,9.3-9,9.3C221.7,170.1,217.7,166.2,217.7,160.8z  M226.8,172c6.1,0,11.3-4.7,11.3-11.2c0-6.4-5.2-11.1-11.3-11.1c-6.1,0-11.3,4.7-11.3,11.1C215.5,167.3,220.7,172,226.8,172z  M224.5,161.7h2.2l3.4,5.6h2.2l-3.7-5.7c1.9-0.2,3.3-1.2,3.3-3.5c0-2.5-1.5-3.7-4.5-3.7h-4.9v12.9h1.9V161.7z M224.5,160v-4h2.7 c1.3,0,2.8,0.3,2.8,1.9c0,2-1.5,2.1-3.1,2.1H224.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl5);
export default __webpack_public_path__ + "static/media/pl5.8596296663d16178dcd92c6ab12647fd.svg";
export { ForwardRef as ReactComponent };